// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import PapuaNewGuinea from '../_raw/flag/icon_flag_papua_new_guinea.png';

export default () => <img src={PapuaNewGuinea} alt="PapuaNewGuinea" />;
